import { createAction, props } from '@ngrx/store';
import { Cartera } from 'src/app/models/cartera.model';


export const listCarteras = createAction('[CARTERAS] List Carteras');

export const addCarteras = createAction('[CARTERAS] Add List Carteras', props<{ list: Cartera[] }>());

export const addCartera = createAction('[CARTERAS] Add Cartera', props<{ cartera: Cartera }>());

export const selectCartera = createAction('[CARTERAS] Select Cartera',props<{id:number}>())

export const updateListCarteras = createAction('[CARTERAS] Update List Carteras', props<{ id: number, cartera: Cartera }>());

export const deleteCartera = createAction('[CARTERAS] Delete Cartera', props<{id: number}>());